import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import sanitizeHtml from 'sanitize-html';
import { AUTO_RENEW_STATUS } from '@src/constants/subscription';
import { PAYMENT_METHOD_TYPE } from '@src/constants/payment';
import useFeatureFlags from '@src/hooks/useFeatureFlags';
import { FEATURE_KEYS } from '@src/configs/featureKeys';
import { StyledPaymentMethodItem } from '../ConfigAutoRenew/index.style';

const PaymentMethodItem = ({
  method,
  isAutoRenewYearPackage,
  isAutoRenew,
  selected,
  onSelect,
  useAutoRenewWithMomo,
}) => {
  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const isUpcomingMethod =
    method.autoRenewStatus === AUTO_RENEW_STATUS.UPCOMING;
  const paymentMethodItemRef = useRef();
  // Disable momo pay if auto renew year package and not use auto renew with momo
  const isDisabled =
    (method.type === PAYMENT_METHOD_TYPE.MOMOPAY && isAutoRenewYearPackage) ||
    (method.type === PAYMENT_METHOD_TYPE.MOMOPAY &&
      isAutoRenew &&
      !useAutoRenewWithMomo);

  const handleSelectBank = () => {
    if (!(isUpcomingMethod || isDisabled)) onSelect(method);
  };

  const paymentMethodName = () => {
    const paymentMethodTranslations = {
      [PAYMENT_METHOD_TYPE.BANK]: t('bankTransfer'),
      [PAYMENT_METHOD_TYPE.VISA]: t('creditCard'),
    };

    return paymentMethodTranslations[method?.type] || method?.name;
  };

  const { getFeatureValue } = useFeatureFlags();
  const vnpayDiscountInfo = getFeatureValue(FEATURE_KEYS.VNPAY_DISCOUNT_INFO);

  return (
    <StyledPaymentMethodItem
      isLogoFullSize={
        ['VISA', '2CHECKOUT'].includes(method?.type) ||
        method?.source === 'VNPAY'
      }
      isNapasCard={method?.type === PAYMENT_METHOD_TYPE.NAPAS_CARD}
      disabled={isUpcomingMethod || isDisabled}
      selected={selected}
      onClick={handleSelectBank}
      ref={paymentMethodItemRef}
      data-id="select-payment-method"
      data-payment-method={method?.type?.toLowerCase()}
    >
      <div className="logo">
        <img src={method && method.logo} alt="i" className="logo-img" />
      </div>
      <div>
        <Typography className="name">{`${paymentMethodName()} ${
          isUpcomingMethod ? `(${t('haveSoon')})` : ''
        } `}</Typography>

        {/* Bank transfer */}
        {method.type === PAYMENT_METHOD_TYPE.BANK && (
          <Typography className="payment-method-desc">
            {t('descriptionBankPaymentMethod')}
          </Typography>
        )}

        {/* MoMo */}
        {method.type === PAYMENT_METHOD_TYPE.MOMOPAY && (
          <Typography className="payment-method-desc">
            {t('momoDescription')}
          </Typography>
        )}

        {/* Napas card */}
        {method.type === PAYMENT_METHOD_TYPE.NAPAS_CARD && (
          <Typography className="payment-method-desc">
            {t('napasCardDescription')}
          </Typography>
        )}

        {/* VNPay */}
        {!isAutoRenew && method.type === PAYMENT_METHOD_TYPE.VNPAYQR && (
          <Typography
            className="payment-method-desc"
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(vnpayDiscountInfo?.[language]),
            }}
          />
        )}
      </div>
    </StyledPaymentMethodItem>
  );
};
export default PaymentMethodItem;
